export default __webpack_public_path__ + "static/media/leftvoting.1ad08e0f.svg";